const handleZero = value => {
  if (value === 0) {
    return '0'
  }
  return value
}

export default handleZero
